/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/control-has-associated-label */
import PropTypes from 'prop-types';
import styles from './SearchButton.module.scss';
import MagnifyingGlassIcon from '../svgs/magnifying-glass';
import CloseIcon from '../svgs/close';

export default function SearchButton({
  theme = null, className = '', open = false, ...childProps
}) {
  const containerName = [
    styles['search-button'],
    theme ? styles[`--theme-${theme}`] : '',
    className,
  ].join(' ');

  return (
    <button className={containerName} {...childProps} type="button">
      {!open && (<MagnifyingGlassIcon />)}
      {open && (<CloseIcon />)}
    </button>
  );
}

SearchButton.propTypes = {
  /**
   * Color theme of button
   */
  theme: PropTypes.oneOf(['white']),
  className: PropTypes.string,
  open: PropTypes.bool,
};
